import React, { useState } from "react";

const DomRoundTrip = ({
  onwardFlights = [],
  returnFlights = [],
  filteredOnwardFlights = [],
  filteredReturnFlights = [],
  filters,
  onFilterChange,
  loading,
  data,
  error,
  handleBookNow,
  requestBody,
}) => {
  const [selectedOnward, setSelectedOnward] = useState(null);
  const [selectedReturn, setSelectedReturn] = useState(null);
  const [selectedFlight, setSelectedFlight] = useState(null);

  // const onwardList =
  //   filteredOnwardFlights?.length > 0 ? filteredOnwardFlights : onwardFlights;

  // const returnList =
  //   filteredReturnFlights?.length > 0 ? filteredReturnFlights : returnFlights;


  const formatTime = (dt) =>
    dt
      ? new Date(dt).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      })
      : "";

  const renderFlights = (list, type) => {
    if (!list || list.length === 0) return <p>No {type} flights found</p>;

    return list.map((f, idx) => {
      const seg = f?.segments?.[0] || {};
      const airLineCode = seg.airLineCode || "";
      const airLineName = seg.airLineName || "Unknown Airline";

      const checked =
        type === "onward"
          ? selectedOnward === idx
          : selectedReturn === idx;

      return (
        <div
          key={idx}
          className={`prodct_lst_round_main rept ${checked ? "selected-flight" : ""
            }`}
        >
          <div className="prodct_lst_round">
            {/* Airline */}
            <div className="item_bx">
              <div className="flight_img_round">
                <img
                  src={`/assets/images/Flight_Images/${airLineCode}.gif`}
                  alt={airLineName}
                  width="50"
                />
              </div>
              <div className="flight_se">
                <span>
                  {airLineCode}-{seg.flightNumber}
                </span>
                <span>{airLineName}</span>
              </div>
            </div>

            {/* Depart */}
            <div className="item_bx">
              <div className="timer">
                <h4>{formatTime(seg.departDateTime)}</h4>
                <p>{seg.departCityName}</p>
              </div>
            </div>

            {/* Duration */}
            <div className="item_bx">
              <div className="deruation">
                <p>{f.totalDuration}</p>
                <div className="bordr_top">
                  <i className="fa fa-plane"></i>
                </div>
                <p className="stops">{f.stops || 0} Stop</p>
              </div>
            </div>

            {/* Arrival */}
            <div className="item_bx text-center">
              <div className="timer">
                <h4>{formatTime(seg.arrivalDateTime)}</h4>
                <p>{seg.arrivalCityName}</p>
              </div>
            </div>

            {/* Fare */}
            <div className="item_bx text-end">
              <input
                className="form-check-input"
                type="radio"
                name={type}
                checked={checked}
                onChange={() =>
                  type === "onward"
                    ? setSelectedOnward(idx)
                    : setSelectedReturn(idx)
                }
              />
              <div className="flight_charge">
                <i className="fa fa-inr"></i>{" "}
                {Number(f?.fares?.[0]?.totalFare || 0).toLocaleString("en-IN")}
              </div>
            </div>
          </div>

          {/* DETAILS CLICK */}
          <div
            className="click_detls_itrm"
            data-bs-toggle="offcanvas"
            data-bs-target="#FlightDetails1"
            onClick={() => {
              const firstSeg = f?.segments?.[0];
              const lastSeg = f?.segments?.[f?.segments?.length - 1];

              setSelectedFlight({
                ...f,
                origin: firstSeg?.departCityName,
                destination: lastSeg?.arrivalCityName,
              });
            }}
          >
            Flight Details
          </div>
        </div>
      );
    });
  };

  const onwardFare =
    selectedOnward !== null
      ? Number(onwardFlights[selectedOnward]?.fares?.[0]?.totalFare || 0)
      : 0;

  const returnFare =
    selectedReturn !== null
      ? Number(returnFlights[selectedReturn]?.fares?.[0]?.totalFare || 0)
      : 0;

  return (
    <>
      <div className="row">
        {/* Onward */}
        <div className="col-md-6 col-6 mb-300">
          <div className="from_to_plc">
            <div className="d_flex">
              <span className="plac_nam">
                {data.departureAirportCode}{" "}
                <i className="fa fa-arrow-right"></i>{" "}
                {data.arrivalAirportCode}
              </span>
              <span className="plac_nam_date">{data.onwardDate}</span>
            </div>

            <div className="list_line">
              <ul>
                <li>Airline</li>
                <li>Depart</li>
                <li>Duration</li>
                <li>Arrival</li>
                <li>Fare</li>
              </ul>
            </div>
          </div>

          {loading ? (
            <p className="text-center">
              <span className="loader"></span>
            </p>
          ) : (
            renderFlights(
              filteredOnwardFlights?.length ? filteredOnwardFlights : onwardFlights,
              "onward"
            )
          )}
        </div>

        {/* Return */}
        <div className="col-md-6 col-6 mb-300">
          <div className="to_to_from_plc">
            <div className="d_flex">
              <span className="plac_nam">
                {data.arrivalAirportCode}{" "}
                <i className="fa fa-arrow-right"></i>{" "}
                {data.departureAirportCode}
              </span>
              <span className="plac_nam_date">{data.returnDate}</span>
            </div>

            <div className="list_line">
              <ul>
                <li>Airline</li>
                <li>Depart</li>
                <li>Duration</li>
                <li>Arrival</li>
                <li>Fare</li>
              </ul>
            </div>
          </div>

          {loading ? (
            <p className="text-center">
              <span className="loader"></span>
            </p>
          ) : (
            renderFlights(
              filteredReturnFlights?.length ? filteredReturnFlights : returnFlights,
              "return"
            )
          )}
        </div>
      </div>

      {/* TOTAL */}
      <div className="total_amount Dom">
        <p className="Grand">Grand Total</p>
        <h1>
          <i className="fa fa-inr"></i>{" "}
          {(onwardFare + returnFare).toLocaleString("en-IN")}
        </h1>

        <button
          className="btn btn-primary"
          disabled={selectedOnward === null || selectedReturn === null}
          onClick={() =>
            handleBookNow({
              onward: onwardFlights[selectedOnward],
              return: returnFlights[selectedReturn],
            })
          }
        >
          Book Now
        </button>

        <button
          className="btn btn-primary"
          data-bs-toggle="modal"
          data-bs-target="#ModifyResult"
        >
          Modify Result
        </button>
      </div>

      {/* OFFCANVAS */}
      <div className="offcanvas offcanvas-end" id="FlightDetails1">
        <div className="offcanvas-header">
          <h1 className="offcanvas-title">Flight Details</h1>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
          ></button>
        </div>

        <div className="offcanvas-body">
          {selectedFlight ? (
            <>
              <ul className="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6">
                <li className="nav-item">
                  <a
                    className="nav-link active"
                    data-bs-toggle="tab"
                    href="#kt_tab_pane_4"
                  >
                    Flight Information
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    data-bs-toggle="tab"
                    href="#kt_tab_pane_5"
                  >
                    Fare Details &amp; Rules
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    data-bs-toggle="tab"
                    href="#kt_tab_pane_6"
                  >
                    Baggage Information
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    data-bs-toggle="tab"
                    href="#kt_tab_pane_7"
                  >
                    Cancellation &amp; Change Rule
                  </a>
                </li>
              </ul>

              <div className="tab-content" id="myTabContent">
                {/* ---------- TAB 1 : FLIGHT INFO ---------- */}
                <div
                  className="tab-pane fade show active"
                  id="kt_tab_pane_4"
                  role="tabpanel"
                >
                  <div className="seLct_tab_flight">
                    <h3 className="destnation">
                      {selectedFlight.origin}
                      <i className="fa fa-arrow-right"></i>
                      {selectedFlight.destination}
                    </h3>

                    <ul className="rlst_flight_detls">
                      <li>
                        {selectedFlight?.tripType === 1
                          ? "One Way"
                          : "Round Trip"}
                      </li>
                      <li>{selectedFlight?.selClass || "Economy"}</li>
                      <li>
                        {(selectedFlight?.adult || 0) +
                          (selectedFlight?.child || 0) +
                          (selectedFlight?.infant || 0)}{" "}
                        Traveller(s)
                      </li>
                      <li>
                        {new Date(
                          selectedFlight?.segments?.[0]?.departDateTime
                        ).toDateString()}
                      </li>
                    </ul>

                    <div className="d-flex flgt_dlts">
                      <div className="img_img_flight">
                        <img
                          className="flight_i"
                          src={`/assets/images/Flight_Images/${selectedFlight?.segments?.[0]?.airLineCode}.gif`}
                          alt={selectedFlight?.segments?.[0]?.airLineName}
                        />
                      </div>

                      <div className="text_img_t">
                        <h5>
                          {new Date(
                            selectedFlight?.segments?.[0]?.departDateTime
                          ).toDateString()}
                        </h5>
                        <p>
                          {selectedFlight.origin} -{" "}
                          {selectedFlight.destination} |{" "}
                          {selectedFlight?.segments?.[0]?.duration ||
                            "Duration N/A"}
                        </p>
                      </div>
                    </div>

                    {/* DEPARTURE INFO */}
                    <div className="d-flex-v">
                      <div className="d-flex-v-f">
                        <h4>
                          {formatTime(
                            selectedFlight?.segments?.[0]?.departDateTime
                          )}
                        </h4>
                      </div>
                      <div className="d-flex-v-m">
                        <span className="zero"></span>
                      </div>

                      <div className="d-flex-v-l">
                        <h4>{selectedFlight.origin}</h4>
                        <p>
                          {
                            selectedFlight?.segments?.[0]
                              ?.departAirportName
                          }
                          {selectedFlight?.segments?.[0]?.departTerminal
                            ? `, Terminal ${selectedFlight?.segments?.[0]?.departTerminal}`
                            : ""}
                        </p>
                      </div>
                    </div>

                    {/* SEGMENT LIST */}
                    <div className="d-flex-v time_to_frm">
                      <div className="d-flex-v-l m-autto">
                        {selectedFlight?.segments?.map((seg, index) => (
                          <div
                            key={index}
                            className="d-flex mb-3 align-items-center"
                          >
                            <div className="d-flex-v-f m-autto me-3">
                              <h6>
                                {new Date(
                                  seg.departDateTime
                                ).toDateString()}
                              </h6>
                              <p className="mb-0">
                                {formatTime(seg.departDateTime)} ➜{" "}
                                {formatTime(seg.arrivalDateTime)}
                              </p>
                            </div>

                            <div className="d-flex-v-m fhty_rg">
                              <i className="fa fa-plane flights"></i>
                            </div>

                            <div className="d-flex">
                              <div className="img_flt">
                                <img
                                  className="flight_i"
                                  src={`/assets/images/Flight_Images/${seg.airLineCode}.gif`}
                                  alt={seg.airLineName}
                                />
                              </div>

                              <div className="flt_name ms-2">
                                {seg.airLineName} - {seg.airLineCode}-
                                {seg.flightNumber}
                                {index <
                                  selectedFlight.segments.length -
                                  1 && (
                                    <span className="mx-2">
                                      <i className="fa fa-arrow-right"></i>
                                    </span>
                                  )}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* ARRIVAL INFO */}
                    <div className="d-flex-v">
                      <div className="d-flex-v-f">
                        <h4>
                          {formatTime(
                            selectedFlight?.segments?.[
                              selectedFlight?.segments?.length - 1
                            ]?.arrivalDateTime
                          )}
                        </h4>
                      </div>

                      <div className="d-flex-v-m">
                        <span className="zero"></span>
                      </div>

                      <div className="d-flex-v-l">
                        <h4>{selectedFlight.destination}</h4>
                        <p>
                          {
                            selectedFlight?.segments?.[
                              selectedFlight?.segments?.length - 1
                            ]?.arrivalAirportName
                          }
                          {selectedFlight?.segments?.[
                            selectedFlight.segments.length - 1
                          ]?.arrivalTerminal
                            ? `, Terminal ${selectedFlight?.segments?.[
                              selectedFlight.segments.length - 1
                            ]?.arrivalTerminal
                            }`
                            : ""}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tab-pane fade" id="kt_tab_pane_5" role="tabpanel">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="fareRuls">

                      </div>
                      <div class="fareRuls">
                        <table class="table table-bordered">
                          <tbody>
                            <tr>
                              <th>
                                Time Frame to reschedule <br />
                                <span>Before scheduled departure time</span>
                              </th>
                              <th>
                                Airline Fees <br />
                                <span>per passenger</span>
                              </th>

                            </tr>
                            <tr>
                              <td>Reschedule before 72 hours of departure time.</td>
                              <td>2,999</td>

                            </tr>
                            <tr>
                              <td>Reschedule within 72 hours &amp; before 24 hours of departure time.</td>
                              <td>2,999</td>

                            </tr>

                          </tbody>
                        </table>
                      </div>
                      <div class="col-md-12 col-lg-12">
                        <h4>Terms &amp; Conditions</h4>
                        <ul>
                          <li>Total Rescheduling Charges Airlines Rescheduling fees Fare Difference if applicable.</li>
                          <li>The airline cancel reschedule fees is indicative and can be changed without any prior notice by the airlines..</li>
                          <li>Berry Journeys does not guarantee the accuracy of cancel reschedule fees.</li>
                          <li>Partial cancellation is not allowed on the flight tickets which are book under special round trip discounted fares.</li>
                          <li>Airlines doesnt allow any additional baggage allowance for any infant added in the booking</li>
                          <li>In certain situations of restricted cases, no amendments and cancellation is allowed</li>
                          <li>Airlines cancel reschedule should be reconfirmed before requesting for a cancellation or amendment</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tab-pane fade" id="kt_tab_pane_6" role="tabpanel">
                  <table class="table table-bordered">
                    <tbody>
                      <tr>
                        <th>Airline</th>
                        <th>Check-in Baggage</th>
                        <th>Cabin Baggage</th>
                      </tr>
                      <tr>
                        <td>
                          <img className="flight_name" src={`/assets/images/Flight_Images/${selectedFlight.segments?.[0]?.airLineCode}.gif`} alt={selectedFlight.segments?.[0]?.airLineName} />
                          <p class="plane_name">{selectedFlight.segments?.[0]?.airLineName}</p>
                          <p class="code_plne">{selectedFlight.segments?.[0]?.airLineCode}-
                            {selectedFlight.segments?.[0]?.flightNumber}</p>

                        </td>
                        <td>15kgs</td>
                        <td>7kgs</td>
                      </tr>
                      <tr>
                        <td>
                          <img className="flight_name" src={`/assets/images/Flight_Images/${selectedFlight.segments?.[0]?.airLineCode}.gif`} alt={selectedFlight.segments?.[0]?.airLineName} />
                          <p class="plane_name">{selectedFlight.segments?.[0]?.airLineName}</p>
                          <p class="code_plne">{selectedFlight.segments?.[0]?.airLineCode}-
                            {selectedFlight.segments?.[0]?.flightNumber}</p>
                        </td>
                        <td>15kgs</td>
                        <td>7kgs</td>
                      </tr>
                      <tr>
                        <td colspan="3">
                          <div class="termsbagg">
                            <ul>
                              <li>Baggage information mentioned above is obtained from airline's reservation system, Berry Journeys does not guarantee the accuracy of this information.</li>
                              <li>The baggage allowance may vary according to stop-overs, connecting flights. changes in airline rules. etc.</li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="tab-pane fade" id="kt_tab_pane_7" role="tabpanel">
                  <div class="fareRuls">
                    <table class="table table-bordered">
                      <tbody>
                        <tr>
                          <th>
                            Time Frame to cancel <br />
                            <span>Before scheduled departure time</span>
                          </th>
                          <th>
                            Airline Fees <br />
                            <span>per passenger</span>
                          </th>

                        </tr>
                        <tr>
                          <td>Cancel Before 72 hours of departure time.</td>
                          <td>3,999</td>
                        </tr>
                        <tr>
                          <td>Cancel within 72 hours &amp; before 24 hours of departure time.</td>
                          <td>3,999</td>
                        </tr>
                        <tr>
                          <td>Cancel within 24 hours &amp; before 4 hours of departure time.</td>
                          <td>4,999</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="fareRuls">
                    <table class="table table-bordered">
                      <tbody>
                        <tr>
                          <th>
                            Time Frame to reschedule <br />
                            <span>Before scheduled departure time</span>
                          </th>
                          <th>
                            Airline Fees <br />
                            <span>per passenger</span>
                          </th>

                        </tr>
                        <tr>
                          <td>Reschedule before 72 hours of departure time.</td>
                          <td>2,999</td>
                        </tr>
                        <tr>
                          <td>Reschedule within 72 hours &amp; before 24 hours of departure time.</td>
                          <td>2,999</td>
                        </tr>
                        <tr>
                          <td>Reschedule within 24 hours &amp; before 4 hours of departure time.</td>
                          <td>2,999</td>
                        </tr>
                        <tr></tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              
              </div>
            </>
          ) : (
            <p>No flight selected</p>
          )}
        </div>
      </div>
    </>
  );
};

export default DomRoundTrip;
